import { Component } from '@angular/core';

@Component({
  selector: 'app-footer',
  templateUrl: './footer.component.html'
})
export class FooterComponent {
}



// WEBPACK FOOTER //
// ./src/app/modules/shared/component/footer/footer.component.ts